import { UrlHelperInstance as urlHelper } from "./urlHelper";

declare var window: any;
declare var appContext: any;

export interface postToParams {
	path: string;
	method?: string;
	params?: any;
	formParams?: any;
	auth?: boolean;
	nocache?: boolean;
}

export const postTo = (path: string | postToParams, params?: any, formParams?: any, auth?: boolean) => {
	var parameters: postToParams;
	let defparams: postToParams = {
		path: '',
		method: "POST",
		params: void 0,
		formParams: void 0,
		auth: true,
		nocache: true
	};
	if (typeof path === 'string') {
		parameters = defparams;
		if (path) {
			parameters.path = path;
		}
		if (params) {
			parameters.params = params;
		}
		if (formParams) {
			parameters.formParams = formParams;
		}
		if (auth === false) {
			parameters.auth = false;
		}
	} else {
		parameters = $.extend({}, defparams, path);
	}

	const createHiddenField = (form: HTMLFormElement, key: string, value: string) => {
		let hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", value);
		return form.appendChild(hiddenField);
	};

	let form = document.createElement("form");
	form.setAttribute("method", parameters.method);
	form.setAttribute("action", parameters.path);
	if (parameters.formParams !== "undefined") {
		for (let key in parameters.formParams) {
			form.setAttribute(key, parameters.formParams[key]);
		}
	}

	let at = (typeof (appContext) != "undefined" && appContext.at) || window.strATTok;
	parameters.auth = parameters.auth && at;

	if (parameters.auth) {
		createHiddenField(form, 'at', at);
	}

	let vers = null;
	if (parameters.nocache && typeof window.getVer == "function") {
		vers = window.getVer()?.toString();
		createHiddenField(form, 'VER', vers);
	}

	if (parameters.formParams && parameters.formParams.download) {
		let fileDownloadCheckTimer = null;

		let finishDownload = () => {
			window.clearInterval(fileDownloadCheckTimer);
			(<any>$).cookie('fileDownloadToken', null);
			return $(document).trigger('closeProcessing');
		};

		let checkFunc = () => {
			let cookieVal = (<any>$).cookie('fileDownloadToken');
			if (cookieVal !== vers) {
				return;
			}
			return finishDownload();
		};

		fileDownloadCheckTimer = window.setInterval(checkFunc, 1000);
		$(document).trigger('showProcessing');
	}

	urlHelper.iterateParams(parameters.params, function (name, value) {
		if (parameters.auth && name === 'AT') {
			return;
		}
		createHiddenField(form, name, value);
	});

	document.body.appendChild(form);
	window.isHaveToLogout = false;
	return form.submit();
};

export const saveFormPosition = (key: string, path?: string) => {
	let arrPanels = [];

	$.each($('[data-toggle="collapse"]'),
		(index, value) => {
			let $value = $(value);
			let panelId = $value.attr('data-target');
			let isPanelExpanded = $value.attr('aria-expanded');
			arrPanels[index] = {
				"id": panelId,
				"isExpanded": isPanelExpanded
			};
		});

	let position = $(window).scrollTop();
	let data = {
		"position": position,
		"panels": arrPanels
	};

	let date = new Date();
	let minutes = 30;
	date.setTime(date.getTime() + (minutes * 60 * 1000));
	let params = { expires: date };
	if (path) {
		params = $.extend(params, { path: path });
	}
	(<any>$).cookie(key, JSON.stringify(data), params);
};

export const restoreFormPosition = (key: string) => {
	return new Promise<void>((resolve) => {
		if (!(<any>$).cookie(key)) {
			resolve();
			return;
		}

		let param = JSON.parse((<any>$).cookie(key));
		let panelsStatus = param["panels"];

		panelsStatus.forEach((panelStatus) => {
			let isExpanded = $(`[data-target="${panelStatus.id}"]`).attr("aria-expanded");
			if (panelStatus.isExpanded != isExpanded) {
				(<any>$(panelStatus.id)).collapse("toggle");
			}
		});

		setTimeout(() => {
			resolve();
			$("html, body").animate({ scrollTop: param["position"] }, 200);
		}, 1000);

		document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
	})
};